import React, { useCallback, useRef, useState } from 'react'
import { CInputGroup, CInputGroupText, } from "@coreui/react";
import SearchIcon from '../../../assets/images/navbar/search.png';
import Autocomplete from 'react-autocomplete';
import { useNavigate } from 'react-router-dom';
import useGlobalSearchListing from '../../../hooks/customHooks/useGlobalSearch';
import { LABEL } from '../../../utils/constants';

export default function GlobalSearch() {
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const [hasSearched, setHasSearched] = useState(false); // Track if search was attempted
    const observer = useRef();
    const { searchData, hasMore, busy, setBusy, handleFetch, setSearchData } = useGlobalSearchListing(
        pageNumber,
        query
    );

    const handleChange = (e) => {
        setPageNumber(1)
        setQuery(e.target.value);
        setIsMenuOpen(true);
        setHasSearched(false);
    };

    const handleSelect = (value, item) => {
        if (item && item.id) {
            navigate(`/projects/view/${item.id}/`)
        }
    };

    const handleResetQuery = () => {
        setQuery('');
        setSearchData([])
        setPageNumber(1)
        setHasSearched(false);
    }

    const lastElRef = useCallback(
        (node) => {
            if (busy) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0]?.isIntersecting && hasMore) setPageNumber((c) => c + 1);
            });
            if (node) observer.current.observe(node);
        },
        [busy, hasMore]
    );

    const getIndex = (item) => searchData?.indexOf(item)
    const getItemValue = item => item.id?.toString() || '';

    const renderItem = (item, highlighted) => {
        if (item.id === 'no-results') {
            return (
                <div className='project-drop no-results' key='no-results' style={{ padding: '10px', textAlign: 'center', color: '#999' }}>
                    <p>No results found</p>
                </div>
            );
        }

        const isLastItem = getIndex(item) + 1 === searchData.length;

        return (
            <div className='project-drop' key={item.id} style={{ padding: '10px', backgroundColor: highlighted ? '#eee' : 'transparent' }}>
                <h2>{item.project_name}</h2>
                {item?.id &&
                    <>
                        <div className='project-sub d-block' ref={isLastItem ? lastElRef : null}>
                            <div className='project-li w-100'><p>Customer:</p><h2>{item.customer}</h2></div>
                        </div>
                        <div className='project-sub'>
                            <div className='project-li'><p>{LABEL?.CLIENT_PROJECT_NUMBER}:</p><h2>{item.project_code}</h2></div>
                            <div className='project-li justify-content-end'><p>Status:</p><h2 className={item?.status.replace(/\s/g, '')}>{item.status}</h2></div>
                        </div>
                    </>
                }
            </div>
        );
    }

    const shouldShowNoResults = query.trim() && hasSearched && !busy && searchData.length === 0;
    const autocompleteItems = shouldShowNoResults
        ? [{ id: 'no-results', project_name: 'No results found' }]
        : searchData;

    return (
        <CInputGroup className="global-search">
            <CInputGroupText>
                <img src={SearchIcon} alt="Search" />
            </CInputGroupText>
            <Autocomplete
                items={autocompleteItems}
                getItemValue={getItemValue}
                renderItem={renderItem}
                value={query}
                onChange={handleChange}
                onSelect={handleSelect}
                open={isMenuOpen && (autocompleteItems.length > 0)}
                onMenuVisibilityChange={(isOpen) => setIsMenuOpen(isOpen)}
                disabled={busy}
                className="global-search"
                inputProps={{
                    placeholder: 'Search by Project name, Client Project Number or Project Ref',
                    onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            setIsMenuOpen(true);
                            setHasSearched(true);
                        }
                    }
                }}
            />
            {query ? <span className="close-btn" onClick={handleResetQuery}>
                <i className="fa fa-times"></i>
            </span> : false}
        </CInputGroup>
    )
}